import { render, staticRenderFns } from "./MonitorRow.vue?vue&type=template&id=152a87ff&scoped=true"
import script from "./MonitorRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MonitorRow.vue?vue&type=style&index=0&id=152a87ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a87ff",
  null
  
)

export default component.exports